import VueI18n from 'vue-i18n';

function _getDayName(day: number, i18n: VueI18n, short = true): string {
  switch (day) {
    case 0:
      return i18n
        .t(`modules.catalog.workingTime.${short ? 'days' : 'daysLong'}.monday`)
        .toString();
    case 1:
      return i18n
        .t(`modules.catalog.workingTime.${short ? 'days' : 'daysLong'}.tuesday`)
        .toString();
    case 2:
      return i18n
        .t(`modules.catalog.workingTime.${short ? 'days' : 'daysLong'}.wednesday`)
        .toString();
    case 3:
      return i18n
        .t(`modules.catalog.workingTime.${short ? 'days' : 'daysLong'}.thursday`)
        .toString();
    case 4:
      return i18n
        .t(`modules.catalog.workingTime.${short ? 'days' : 'daysLong'}.friday`)
        .toString();
    case 5:
      return i18n
        .t(`modules.catalog.workingTime.${short ? 'days' : 'daysLong'}.saturday`)
        .toString();
    case 6:
      return i18n
        .t(`modules.catalog.workingTime.${short ? 'days' : 'daysLong'}.sunday`)
        .toString();
  }

  return '';
}

export default _getDayName;
